import { render, staticRenderFns } from "./CommissionList.vue?vue&type=template&id=2c0bd652&scoped=true&"
import script from "./CommissionList.vue?vue&type=script&lang=js&"
export * from "./CommissionList.vue?vue&type=script&lang=js&"
import style0 from "./CommissionList.vue?vue&type=style&index=0&id=2c0bd652&lang=scss&scoped=true&"
import style1 from "./CommissionList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0bd652",
  null
  
)

export default component.exports